import type { TypeLang } from '@/utils'

export const getDictionary = async (locale:TypeLang) => {
  const project = await import(`./dictionaries/${locale}.json`).then(module => module.default)
  return { ...project }
}
